import { Box } from "@mui/material"
import { ProductModal } from "./ProductModal"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CategoryData } from "../../types";

interface AddProductProps {
  refetchProducts: () => void;
  categories: CategoryData[];
}

export const AddProduct = ({ refetchProducts, categories }: AddProductProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/products');
  }

  const handleSave = () => {
    navigate('/products');
    refetchProducts();
  }
  
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="add-product">
      <ProductModal open={open} handleClose={handleClose} handleSave={handleSave} product={{  }} categories={categories} />
    </Box>
  )
}